import React from 'react';

const DrupalOauthContext = React.createContext(null);

export default DrupalOauthContext;
